export const getAllPollList = (state, timelinePollList, totalPoll) => {
  return {
    ...state,
    pollQuestion: [...state.pollQuestion, ...timelinePollList],
    total: totalPoll,
  };
};

export const setPollLoader = (state, loaderValue) => {
  return {
    ...state,
    isLoading: loaderValue,
  };
};

export const updatePoll = (state, poll) => {
  const pollQuestionCopy = [...state.pollQuestion];

  pollQuestionCopy[
    pollQuestionCopy.findIndex((tPollQuestion) => {
      return tPollQuestion.id === poll.id;
    })
  ] = {
    ...poll,
  };

  return {
    ...state,
    pollQuestion: pollQuestionCopy,
  };
};

export const createPoll = (state, poll) => {
  var newPollQuestion = Array.from(new Set([poll, ...state.pollQuestion]));

  return {
    ...state,
    total: state.total + 1,
    pollQuestion: newPollQuestion,
  };
};

export const deletePoll = (state, id) => {
  var newPollQuestion = state.pollQuestion.filter(
    (pollQuestion) => pollQuestion.id !== parseInt(id)
  );

  return {
    ...state,
    total: state.total - 1,
    pollQuestion: newPollQuestion,
  };
};

export const pollPageIncreament = (state) => {
  var newPage = state.page + 1;

  return {
    ...state,
    page: newPage,
  };
};

export const clearAllPoll = () => {
  return {
    pollQuestion: [],
    total: "",
    page: 1,
    isLoading: true,
  };
};
